<script setup lang="ts">

</script>

<template>
  <section>
    <article>
      <p>
        Na de Tweede Wereldoorlog lag een groot deel van Nederland in puin. Huizen, bruggen en steden waren verwoest. Maar
        Nederlanders gaven niet op: samen begonnen ze met de wederopbouw van ons land.
      </p>
      <p>
        Op deze website speel je leuke en leerzame spellen over die tijd. Ontdek hoe mensen toen leefden, werkten en
        Nederland weer opbouwden.
      </p>
      <p>
        Klaar om zelf te helpen met opbouwen?
      </p>
      <router-link to="/games">Spellen starten <i class="fa-solid fa-gamepad"></i></router-link>
    </article>
  </section>
</template>

<style scoped>

section {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  height: 200vh;
  background: var(--filter-dimmed), url("../assets/images/ChatGPT Image May 25, 2025, 09_13_15 PM.png");
  background-size: cover;
}


article {
  margin: 0 30vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;

  p {
    font-size: 1.5em;
    text-align: center;
    margin: 0.4em auto;
  }

  a {
    font-size: 1.5em;
    text-align: center;
    margin: 0.4em auto;
  }
}

@media screen and (max-width: 800px) {
  article {
    margin: 0 5vw;
    p {
      font-size: 1.25em;
    }
  }
}
</style>